import React, { useEffect, useState } from 'react';
import axios from 'axios';
import filterParams from '../utils/filterParams';

export default function ConversationRegister({ filters }) {
  const [search, setSearch] = useState('');
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ total: 0, data: [] });
  const [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    const params = filterParams(filters, { page, search: query });
    axios
      .get(`/api/decision/conversations?${params}`, { signal: controller.signal })
      .then((response) => {
        setData(response.data);
        setError('');
      })
      .catch((err) => {
        if (!axios.isCancel(err)) setError(err.response?.data?.error || 'Could not load conversations.');
      });
    return () => controller.abort();
  }, [filters, query, page]);
  return (
    <section className="decision-pane conversation-register">
      <header>
        <h3>Conversation register</h3>
        <p>
          {data.total} conversations in the selected dashboard scope. Search transcripts, field team members
          or locations.
        </p>
      </header>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          setPage(1);
          setQuery(search);
        }}
      >
        <input
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          placeholder="Search conversations"
        />
        <button type="submit">Search</button>
      </form>
      {error && <p>{error}</p>}
      <div className="conversation-register-list">
        {data.data.map((row) => (
          <details key={row.conversation_id}>
            <summary>
              <b>{String(row.call_date || '').slice(0, 10)}</b>
              <span>
                {row.region_name || 'Location unknown'}
                {row.state ? `, ${row.state}` : ''}
              </span>
              <span>{row.agent_name || 'Field team member unknown'}</span>
              <small>Conversation {row.conversation_id}</small>
            </summary>
            <p>{row.raw_transcript || 'Transcript unavailable.'}</p>
          </details>
        ))}
      </div>
      <footer>
        <button disabled={page === 1} onClick={() => setPage((value) => value - 1)}>
          Previous
        </button>
        <span>
          Page {page} of {Math.max(1, Math.ceil(data.total / 25))}
        </span>
        <button disabled={page * 25 >= data.total} onClick={() => setPage((value) => value + 1)}>
          Next
        </button>
      </footer>
    </section>
  );
}
